import t from"./_getTag.js";import r from"./isObjectLike.js";var e="[object Map]";function o(o){return r(o)&&t(o)==e}export{o as default};
//# sourceMappingURL=_baseIsMap.js.map
